import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WorkspacesPage } from '@/features/admin/workspaces/workspace-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « vscode » de la navigation : les espaces de travail de ce type (revue C13). */
export const Route = createFileRoute('/$tenant/vscode')({ component: VsCodeRoute });

function VsCodeRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="vscode" crumbs={[{ label: t('nav.items.vscode') }]}>
      <WorkspacesPage tenantId={tenant} kind="vscode" />
    </ConsoleShell>
  );
}
